const INITIAL_STATE = {
  loading: false,
  list: {
    content: [],
    defaultValues: [],
  },
  total: 0,
  error: false,
  errors: [],
  importResults: [],
  deleteError: false,
  deleteErrors: [],
  deleteResults: [],
  contactDetails: {},
  loadingActivities: false,
  buttonLoading: false,
  earnPointsTransactions: [],
  loadingEarnPointsTransactions: false,
  supportMessages: [],
  loadingSupportMessages: false,
  registrationAuthorizations: [],
  loadingRegistrationAuthorizations: false,
  registrationAuthorizationButtonLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CONTACTS_FETCHED':
      return { ...state, list: { content: action.payload }, loading: false };
    case 'CONTACTS_LOAD':
      return { ...state, loading: action.payload };
    case 'CONTACTS_LIST_FETCHED':
      return { ...state, list: { defaultValues: action.payload }, loading: false };
    case 'CONTACTS_LIST_LOAD':
      return { ...state, loading: action.payload };
    case 'CONTACTS_TOTAL_FETCHED':
      return {
        ...state,
        userTotal: action.payload,
        loading: false,
      };
    case 'CONTACT_IMPORT_HAS_ERROR':
      return { ...state, error: action.payload };
    case 'CONTACT_IMPORT_ERRORS':
      return { ...state, errors: action.payload };
    case 'CONTACT_IMPORT_RESULTS':
      return { ...state, importResults: action.payload };
    case 'CONTACT_DELETE_HAS_ERROR':
      return { ...state, deleteError: action.payload };
    case 'CONTACT_DELETE_ERRORS':
      return { ...state, deleteErrors: action.payload };
    case 'CONTACT_DELETE_RESULTS':
      return { ...state, deleteResults: action.payload };
    case 'CONTACT_DETAIL_LOAD':
      return { ...state, loadingActivities: action.payload };
    case 'CONTACT_DETAIL_FETCHED':
      return {
        ...state,
        contactDetails: action.payload[0],
        loadingActivities: false,
      };
    case 'CONTACT_EARN_POINTS_TRANSACTIONS_LOAD':
      return { ...state, loadingEarnPointsTransactions: action.payload };
    case 'CONTACT_EARN_POINTS_TRANSACTIONS_FETCHED':
      return {
        ...state,
        earnPointsTransactions: action.payload,
        loadingEarnPointsTransactions: false,
      };
    case 'CONTACT_SUPPORT_MESSAGES_LOAD':
      return { ...state, loadingSupportMessages: action.payload };
    case 'CONTACT_SUPPORT_MESSAGES_FETCHED':
      return {
        ...state,
        supportMessages: action.payload,
        loadingSupportMessages: false,
      };
    case 'CONTACT_BUTTON_LOAD':
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case 'REGISTRATION_AUTHORIZATIONS_LOAD':
      return { ...state, loadingRegistrationAuthorizations: action.payload };
    case 'REGISTRATION_AUTHORIZATIONS_FETCHED':
      return {
        ...state,
        registrationAuthorizations: action.payload,
        loadingRegistrationAuthorizations: false,
      };
    case 'REGISTRATION_AUTHORIZATION_BUTTON_LOAD':
      return { ...state, registrationAuthorizationButtonLoading: action.payload };

    default:
      return state;
  }
};
